'use strict'

const _ = require('lodash')
const React = require('react')
const ReactDOM = require('react-dom')
const createReactClass = require('create-react-class')
const PropTypes = require('prop-types')
const withBehavior = require('../../../HOC/withBehaviors')
const baseCompMixin = require('../../../mixins/baseCompMixin')
const santaTypesDefinitions = require('../../../definitions/santaTypesDefinitions')
const getPopoverLocation = require('../utils/getPopoverLocation')
const boundingUtils = require('../../../utils/boundingUtils')

const createTargetWrapper = (targetBounds, element, onTargetMouseIn, onTargetMouseOut) => React.createElement('div', {
    style: _.defaults({
        position: 'absolute'
    }, targetBounds),
    onMouseEnter: onTargetMouseIn,
    onMouseLeave: onTargetMouseOut
}, element)

const createPopoverWrapper = (id, popoverElement, popoverStyle, ref, compProp, onPopoverMouseIn, onPopoverMouseOut) => {
    const props = {
        ref,
        style: _.assign({
            position: 'absolute',
            width: 'auto',
            height: 'auto'
        }, getPopoverLocation(compProp.position, compProp.alignment, compProp.horizontalOffset, compProp.verticalOffset)),
        onMouseEnter: e => {
            e.stopPropagation()
            onPopoverMouseIn()
        },
        onMouseLeave: e => {
            e.stopPropagation()
            onPopoverMouseOut()
        },
        'data-aid': id
    }

    return React.createElement('div', props, React.cloneElement(popoverElement, {style: popoverStyle}))
}

const behaviorsDef = {
    hidePopover: {methodName: 'hide'},
    showPopover: {methodName: 'show', params: ['targetId']}
}

const Popover = createReactClass({
    displayName: 'Popover',

    mixins: [baseCompMixin.baseComp],

    propTypes: {
        id: santaTypesDefinitions.Component.id.isRequired,
        compProp: santaTypesDefinitions.Component.compProp.isRequired,
        style: santaTypesDefinitions.Component.style.isRequired,
        rootContentStyle: santaTypesDefinitions.Popover.rootContentStyle,
        open: santaTypesDefinitions.Popover.open.isRequired,
        close: santaTypesDefinitions.Popover.close.isRequired,
        onPopoverMouseIn: santaTypesDefinitions.Popover.onPopoverMouseIn.isRequired,
        onPopoverMouseOut: santaTypesDefinitions.Popover.onPopoverMouseOut.isRequired,
        onTargetMouseIn: santaTypesDefinitions.Popover.onTargetMouseIn.isRequired,
        onTargetMouseOut: santaTypesDefinitions.Popover.onTargetMouseOut.isRequired,
        targetBounds: santaTypesDefinitions.Popover.targetBounds,
        targetPortal: santaTypesDefinitions.Popover.targetPortal,
        isQAMode: santaTypesDefinitions.isQAMode,
        children: PropTypes.node
    },

    hide(callback) {
        this.props.close()
        if (_.isFunction(callback)) {
            callback()
        }
    },

    show(targetId, callback) {
        this.props.open(targetId, {
            closeMethod: this.props.compProp.closeMethod
        })
        if (_.isFunction(callback)) {
            callback()
        }
    },

    onDocumentClick(e) {
        const contentWrapperBounding = this.contentWrapperRef.current.getBoundingClientRect()
        if (!boundingUtils.isInBounds(contentWrapperBounding, e.clientX, e.clientY)) {
            this.props.close()
        }
    },

    componentWillMount() {
        this.contentWrapperRef = React.createRef()
    },

    render() {
        const {id, compProp, structure, style, targetBounds, targetPortal, children, rootContentStyle} = this.props

        if (children) {
            _.assign(style, {pointerEvents: 'none'})
        }

        const props = {id, style}

        if (this.props.isQAMode) {
            _.assign(props, {'data-comp': structure.componentType})
        }

        if (this.props.targetBounds) {
            const content = children[0]
            const popoverWrapper = createPopoverWrapper(id, content, rootContentStyle, this.contentWrapperRef, compProp, this.props.onPopoverMouseIn, this.props.onPopoverMouseOut)
            const targetWrapper = createTargetWrapper(targetBounds, popoverWrapper, this.props.onTargetMouseIn, this.props.onTargetMouseOut)
            const elementInPortal = ReactDOM.createPortal(targetWrapper, targetPortal)
            return React.createElement('div', props, elementInPortal)
        }

        return React.createElement('div', props, children)
    }
})

module.exports = withBehavior(behaviorsDef)(Popover)